<template>
    <div class="detail-page">
        <div class="detail-page__header">
            <z-link
                size="m"
                :href="computedBackLink"
                class="detail-page__info detail-page__info--link"
            >
                <z-icon
                    width="18"
                    height="16"
                    name="btn-arrow-2"
                />{{ computedBackLinkText }}
            </z-link>
        </div>
        <article class="detail-page__body html-content">
            <z-lead class="u-bottom-margin--triple">
                <h2 class="u-margin--no">{{ title }}</h2>
            </z-lead>
            <time
                v-if="this.data.date ? this.data.date : this.date"
                class="detail-page__date"
            >{{ this.data.date ? this.data.date : this.date | momentFilter('DD MMMM YYYY') }}</time>
            <slot name="content">
                <z-preloader v-if="loading" />
                <div v-html="data.html"></div>
            </slot>
        </article>
        <detail-page-prev-next-controls v-if="showPrevNextControls && data.nav" :nav="data.nav" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'detail-page',
    props: {
        static: {
            type: String
        },
        component: {
            type: String
        },
        title: {
            type: String,
            default: ''
        },
        html: {
            type: String,
            default: ''
        },
        backLink: {
            type: String,
            default: ''
        },
        backLinkText: {
            type: String,
            default: ''
        },
        showPrevNextControls: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            loading: false,
            rnsDB: {
                '33b976702dc8e94e4bb6eabe7e0ec321': {
                    date: 1659598675,
                    name: 'EVRAZ plc: UNAUDITED INTERIM FINANCIAL RESULTS FOR H1 2022U EQS  04 August 2022  07:37:55'
                },
                '0cb9be7bed911971213100c22965a1ea': {
                    date: 1660147205,
                    name: 'EVRAZ is launching soliciting of proposals for its North American subsidiaries acquisition EQS  10 August 2022  16:00:05'
                }
            },
            text: {
                backLinkTextDefault: this.$root.lang === 'ru' ? 'Назад к списку' : 'Back to the facts'
            }
        }
    },
    created () {
        this.setBannerIfSended()

        if (this.component === 'rns-detail') {
            this.loading = true

            try {
                let path = null
                if (this.static) {
                    path = `https://storage.zds.zebra-group.ru/data/13/12/${this.static}.html`
                } else if (this.$root.app.components[this.component]) {
                    path = this.$root.app.components[this.component]?.data?.files[0]?.path
                }

                if (path) {
                    fetch(path)
                        .then((response) => response.text())
                        .then((text) => {
                            this.data.html = text
                            this.loading = false
                        })
                }
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        }
    },
    methods: {
        setBannerIfSended () {
            if (this.data && this.data.image && this.data.image !== '') {
                this.SetHeroSrc(this.data.image)
            }

            if (this.component === 'rns-detail' && this.data) {
                const arStr = this.data.name.split('  ')
                let result
                if (arStr[0].toLowerCase().indexOf('rns') >= 0 || arStr[0].toLowerCase().indexOf('eqs') >= 0) {
                    result = arStr[0].substr(0, arStr[0].lastIndexOf(' '))
                } else {
                    result = arStr[0]
                }
                this.SetHeroTitle(result)
            }
        },
        ...mapActions(['SetHeroSrc', 'SetHeroTitle'])
    },
    computed: {
        data () {
            if (this.component) {
                if (this.component === 'rns-detail' && this.static) {
                    return {
                        'back-link': '/en/investors/regulatory-news/',
                        name: this.rnsDB[this.static].name,
                        html: '',
                        date: this.rnsDB[this.static].date,
                        title: '',
                        image: ''
                    }
                } else if (this.component === 'rns-detail') {
                    return {
                        date: this.$root.app.components[this.component].data.date,
                        ...this.$root.app.components[this.component]
                    }
                } else {
                    return this.$root.app.components[this.component]
                }
            }

            return {
                html: this.html,
                date: this.date,
                title: this.title,
                image: this.image
            }
        },
        computedBackLink () {
            if (this.data && this.data['back-link']) {
                return this.data['back-link']
            }
            return this.backLink ? this.backLink : '/'
        },
        computedBackLinkText () {
            return this.backLinkText ? this.backLinkText : this.text.backLinkTextDefault
        }
    }
}
</script>

<style lang="scss">
.detail-page {

    &__header {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        margin-bottom: $token-spacers-xl;
    }

    &__info {

        &:before {
            content: '\007C';
            margin: 0 $token-spacers-s;
            font-size: 16px;
            line-height: 1.5;
            color: #F1F1F1;
        }

        &--link {
            &:hover {
                .z-icon {
                    transform: rotate(180deg) translateX(2px);
                }
            }

            .z-icon {
                vertical-align: text-top;
                margin-right: $token-spacers-s;
                transform: rotate(180deg);
                transition: transform 0.1s linear;
            }

            &:before {
                content: none;
            }

            @media print {
                display: none;
            }
        }
    }

    &__date {
        display: block;
        margin-bottom: $token-spacers-m;
        font-size: 18px;
        line-height: 27px;
        color: $token-colors-black;
    }
}
</style>
